import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { ListingHistory } from "../listing-history";
import { ListingAudit } from "../listing-audit";

@Component({
	selector: "app-history-row",
	templateUrl: "./history-row.component.html",
	styleUrls: ["./history-row.component.scss"],
})
export class HistoryRowComponent {
	@Input() listingHistories: ListingHistory[] | ListingAudit;
	@Input() showDifference = false;
	@Input() modifyListingAudit: boolean = false;
	@Output() handleDeleteEvent?: EventEmitter<ListingAudit> = new EventEmitter();
	@HostBinding("class.card") cardClass = true;

	constructor() {}

	deleteListingHistory(listingHistory: ListingAudit) {
		this.handleDeleteEvent.emit(listingHistory);
	}

	isListingAudit = (data): data is ListingAudit => {
		return (data as ListingAudit).listingAuditSK !== undefined;
	};
}
